import * as R from 'ramda'

import * as websockets from '@rushplay/websockets'

import * as types from './types'
import { NotificationLevel } from './levels'
import { add, dismiss } from './actions'

export function reducer(state = [], action) {
  if (action.error) {
    return reducer(
      state,
      add({
        level: NotificationLevel.ERROR,
        message: action.payload.message,
        variables: action.payload.variables,
      })
    )
  }

  switch (action.type) {
    case types.ADDED: {
      const nextState = R.reduce(
        (nextState, notification) => {
          return R.path(['message'], notification) === action.payload.message
            ? reducer(state, dismiss(notification.id))
            : state
        },
        state,
        state
      )

      return R.append(
        R.mergeDeepRight(action.payload, { id: state.length }),
        nextState
      )
    }

    case types.DISMISSED: {
      return R.update(action.payload, null, state)
    }

    case websockets.SESSION_EXPIRED:
    case types.DISMISSED_ALL: {
      return []
    }

    default: {
      return state
    }
  }
}
